var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"user-link",attrs:{"href":("/user/?id=" + _vm.id),"target":"_blank"}},[_vm._t("default",[_vm._v(_vm._s(_vm.name))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }